import { FormData } from './dataLayer';
import { dateDiffInDays, getLabelForAge, getOldArea, getQueryParamFromWindowOrIframe, isControl, } from '../utils';
import { allAgeGrpFieldsNames, ANNUAL_COVER_VALUE, ERR_MSGS, getSubmitUrl, GROUPS_TYPE, } from '../constants';
import Validation from './validationLayer';
import { addActiveClassToRadios } from './ui';
import { setLocalItem } from './store/localStore';
export class StepOneController {
    constructor() {
        this.dataLayer = new FormData();
        this.attachEventListeners();
        this.form = document.getElementById('quote-form');
        this.validationLayer = new Validation(this.dataLayer, this.form);
    }
    attachEventListeners() {
        addActiveClassToRadios(this.dataLayer, this.submitForm.bind(this));
    }
    updateGroupCount(form) {
        const ageErrrBox = document.querySelector('#qq__agegroup--variant .error__message');
        const takenGrpFieldNames = [];
        const allInputFields = document.querySelectorAll('.age-groups__input');
        let invalidAgeExists = false;
        let belowZeroAgeExists = false;
        let notANumberExists = false;
        allInputFields.forEach((inputField) => {
            const fieldValue = parseInt(inputField.value, 10);
            if (fieldValue > 74) {
                invalidAgeExists = true;
            }
            if (fieldValue < 0) {
                belowZeroAgeExists = true;
            }
            // if (isNaN(fieldValue)) {
            //   notANumberExists = true;
            // }
            takenGrpFieldNames.push(inputField.id);
        });
        const packageContainer = document.querySelector(isControl()
            ? '.qq-packages-type--control .error__message'
            : '.qq-packages-type--variant .error__message');
        // value should only be between 0 and 74
        if (invalidAgeExists) {
            packageContainer.classList.add('error', 'required');
            ageErrrBox.textContent = ERR_MSGS.errorMsgMaxAge;
            return true;
        }
        else if (belowZeroAgeExists) {
            packageContainer.classList.add('error', 'required');
            ageErrrBox.textContent = ERR_MSGS.errorMSG_LowAgeValue;
            return true;
        }
        else if (notANumberExists) {
            packageContainer.classList.add('error', 'required');
            ageErrrBox.textContent = ERR_MSGS.errorMSG_OnlyNumbers;
            return true;
        }
        else {
            packageContainer.classList.add('error', 'required');
            ageErrrBox.textContent = ERR_MSGS.errorMsgNone;
        }
        const ageGrpCountPair = takenGrpFieldNames.reduce((acc, curr) => {
            const fieldValue = document.getElementById(curr)
                .value;
            if (fieldValue || fieldValue == '0') {
                const age = parseInt(fieldValue, 10);
                const label = getLabelForAge(age);
                if (acc[label]) {
                    acc[label] += 1;
                }
                else {
                    acc[label] = 1;
                }
            }
            return acc;
        }, {});
        packageContainer.classList.remove('error', 'required');
        this.resetAndSetAgeGrps(form, ageGrpCountPair);
        return false;
    }
    // !!! START HERE
    // !!! REMOVE THIS CODE ONCE THE VARIANT WON
    updateControlGroupCount(form) {
        const ageErrorBox = document.querySelector('#qq__agegroup--control .error__message');
        const packageContainer = document.querySelector('.qq-packages-type--control');
        const totalPersonCount = Object.entries(this.dataLayer.getAll()).reduce((count, [key, value]) => {
            if (GROUPS_TYPE.includes(key)) {
                const parsedValue = typeof value === 'number' ? value : Number(value);
                return !isNaN(parsedValue) ? count + parsedValue : count;
            }
            return count;
        }, 0);
        if (totalPersonCount === 0) {
            packageContainer.classList.add('error', 'required');
            ageErrorBox.textContent = ERR_MSGS.errorMSG_minPartySize;
            return true;
        }
        return false;
    }
    resetAndSetAgeGrps(form, ageGrpCountPair) {
        GROUPS_TYPE.forEach((grpType) => {
            const ageGrpCount = ageGrpCountPair[grpType];
            if (ageGrpCount) {
                form.set(grpType, ageGrpCount);
                setLocalItem(grpType, ageGrpCount);
            }
            else {
                form.set(grpType, 0);
                setLocalItem(grpType, 0);
            }
        });
    }
    buildDymanicValues() {
        // build the response code
        const responseCodeVal = getQueryParamFromWindowOrIframe('responseCode');
        if (responseCodeVal) {
            this.dataLayer.set('responseCode', responseCodeVal);
        }
        // handles the number of trip days
        if (this.dataLayer.get('coverType') != ANNUAL_COVER_VALUE) {
            if (this.dataLayer.get('numberOfAdults') == 'NaN' ||
                isNaN(this.dataLayer.get('numberOfAdults'))) {
                const startDate = this.dataLayer.get('startDate');
                const endDate = this.dataLayer.get('endDate');
                try {
                    const dateDiff = dateDiffInDays(startDate, endDate);
                    if (!isNaN(dateDiff)) {
                        this.dataLayer.set('numberOfTripDays', dateDiff);
                    }
                }
                catch (error) {
                    console.error(error);
                }
            }
        }
        else {
            this.dataLayer.set('numberOfTripDays', 31);
        }
        // updated the source code from the searhc bar qp
        const sourceCodeVal = getQueryParamFromWindowOrIframe('sourceCode') || '';
        if (sourceCodeVal) {
            this.dataLayer.set('sourceCode', sourceCodeVal);
        }
        // clear the enddate for annual plan
        const selectedCoverType = this.dataLayer.get('coverType');
        if (selectedCoverType === ANNUAL_COVER_VALUE) {
            this.dataLayer.set('endDate', '');
        }
        // change this to upper case for it to work on the new qe same logic is applied on the backend
        this.dataLayer.set('sourceCode', this.dataLayer.get('sourceCode').toUpperCase());
        // !!! START HERE
        // !!! REMOVE THIS CODE ONCE THE VARIANT WON
        if (!isControl()) {
            return this.updateGroupCount(this.dataLayer);
        }
        else {
            return this.updateControlGroupCount(this.dataLayer);
        }
    }
    buildSubmitURL() {
        const toSubmit = [];
        const tempSourceCode = this.dataLayer.get('sourceCode');
        const tempCoverType = this.dataLayer.get('coverType').slice(0, -2);
        this.dataLayer.set('promotionCode', tempSourceCode);
        this.dataLayer.set('policyTypeOption', tempCoverType);
        if (tempCoverType === 'MT_MT_N') {
            this.dataLayer.set('policyType', 'MT');
        }
        else {
            this.dataLayer.set('policyType', 'ST');
        }
        for (const formName in this.dataLayer.getAll()) {
            if (isControl()) {
                if (formName === 'area') {
                    this.dataLayer.set('area', getOldArea(this.dataLayer.get('area')));
                }
                toSubmit.push(`${formName}=${this.dataLayer.get(formName)}`);
            }
            else {
                if (this.dataLayer.get(formName) !== undefined &&
                    this.dataLayer.get(formName) !== '' &&
                    this.dataLayer.get(formName) !== 'DD/MM/YYYY' &&
                    this.dataLayer.get(formName) !== 0) {
                    toSubmit.push(`${formName}=${this.dataLayer.get(formName)}`);
                }
                else {
                    if ((allAgeGrpFieldsNames.includes(formName) &&
                        this.dataLayer.get(formName) === 0) ||
                        (allAgeGrpFieldsNames.includes(formName) &&
                            this.dataLayer.get(formName) === '0')) {
                        toSubmit.push(`${formName}=0`);
                    }
                }
            }
        }
        const submitURL = encodeURI(getSubmitUrl() + toSubmit.join('&'));
        return submitURL;
    }
    submitForm() {
        const errorMandatory = this.validationLayer.validateFormInput();
        if (errorMandatory) {
            this.validationLayer.displayError(errorMandatory);
            return;
        }
        const errorExist = this.buildDymanicValues();
        if (errorExist) {
            return;
        }
        const error = this.validationLayer.validateAllInputForm();
        if (!error.isValid)
            return;
        const submitURL = this.buildSubmitURL();
        if (error.isValid) {
            window.location.href = submitURL;
        }
    }
}
